import {type ImgHTMLAttributes, useState} from 'react';

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
}

export function Image({
  src,
  alt,
  className,
  fallbackSrc = 'https://placehold.co/600x400?text=Image',
  ...props
}: ImageProps) {
  const [error, setError] = useState(false);

  return (
    <img
      src={error ? fallbackSrc : src}
      alt={alt || ''}
      className={className}
      onError={() => setError(true)}
      loading="lazy"
      {...props}
    />
  );
}
